module.exports = __webpack_public_path__ + "img/icon-72x72.421488e0.png";